// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductOption_root__1jCUp","image":"ProductOption_image__2L3WT","title":"ProductOption_title__2oN8P","radioCheck":"ProductOption_radioCheck__89Eeh"};